import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, catchError, of, takeUntil, tap } from 'rxjs';
import { TitleService } from '../../Services/title.service';
import { ValidationService } from '../../Services/validation.service';
import { JwtService } from '../../Services/jwt.service';
import { SharedService } from '../../Services/shared.service';
import { JobSeekerService } from 'src/app/job-seeker/Services/job-seeker.service';
import { LoggingService } from '../../Services/NGLogger/logging-service.service';
import { JsDataService } from 'src/app/job-seeker/Services/js-data.service';
import { BaseComponent } from '../base/base.component';
import { environment } from 'src/environments/environment';
import { DocType, LookUpConstants } from 'src/app/job-seeker/Models/constant';
import { inputs } from '@syncfusion/ej2-angular-richtexteditor/src/rich-text-editor/richtexteditor.component';

@Component({
  selector: 'app-doc-upload',
  templateUrl: './doc-upload.component.html',
  styleUrls: ['./doc-upload.component.css']
})
export class DocUploadComponent extends BaseComponent  {
  private componentDestroyed$: Subject<void> = new Subject(); // For unsubscribing when the component is destroyed
  @Output() saveDocClicked = new EventEmitter<void>();
  @Output() dataEmitted = new EventEmitter<{ docData: any }>();
  @Input() childData: any;
  @Input() Id:any  
  @Input() docType: any;
  @Input() saveDocumentOnUpload: boolean = false;
  docsForm!: FormGroup<any>;
  gridData: any[] = [];
  modelData: any[] = [];
  docData: any[] = [];

  originalDocType: any;
  submitted: any;
  isFormDisabled: boolean = true;
  isEditMode: boolean = false;
  isOtherSel: boolean = false;
  docTypeList : any;
  isDocListUpdated:boolean=false;
  documentTypes: { key: string; label: string; accept: string }[] = [];  
  isRequired = false;
  isDeletePopUp : boolean = false;
  constructor(
    private titleService: TitleService,
    private validationService: ValidationService,
    private jwtService: JwtService,
    private shareService: SharedService,
    private jobSeekerService: JobSeekerService,
    private formBuilder: FormBuilder,
    private loggingService: LoggingService,
    private jsService: JsDataService
  ) {
    super();
    this.docTypeList = DocType;    
  }

  ngOnChanges(changes: SimpleChanges) {
   if(this.childData)
    {
      this.gridData=this.childData;
    } 
  }

  updateDocForm(childData: any): void {
    this.docsForm!.patchValue({ ...childData });
    this.gridData = childData;
    this.modelData = this.gridData;
  }

  handleChildDataChanges(childData: any): void {
    this.updateDocForm(childData);
  }

  // getAcceptValue(key: string): string {
  //   switch (key) {
  //     case 'RESUME':
  //       return ".pdf,.doc,.docx";
  //     case 'IMAGE':
  //       return "image/png, image/jpeg";
  //     default:
  //       return '';
  //   }
  // }

  onOptionChange() {
    this.resetVisibility();
  }

  resetVisibility() {
    for (const docType of this.documentTypes) {
      this.docsForm.get(docType.key)?.setValue(null);
    }
  }

  isVisible(docType: any) {
    return this.docsForm.get('docType')?.value === docType.key;
  }

  hasVisibleDocType() {
    return this.documentTypes.some(docType => this.isVisible(docType));
  }

  override ngOnInit(): void {
    this.formInit();   
    if (this.Id == 0 || this.Id == undefined || this.Id == null) {
      this.docsForm.disable();
    }
    else {
      this.enableForm();
    }
  }

  enableForm() {
    this.isFormDisabled = false;
    this.isEditMode = true;
    this.docsForm.enable()
  }

  DocsSubmit() {
    const docData = this.gridData;
    this.dataEmitted.emit({ docData });
  }

  saveDocs() {
    this.submitted = true;
    this.isRequired = true;
    if (this.docsForm.controls?.['Id'].value == null || this.docsForm.controls?.['Id'].value == '') {
      this.docsForm?.controls['Id']?.setValue(this.Id);
    }
    let desc= this.docsForm.controls?.['docType']?.value.displayName;
    if (this.docsForm.invalid) return;
    this.copyFormValues(this.docsForm, this.docsForm, [
      { sourceControlName: 'docType', targetControlName: 'docType', nestedKey: 'lookUpCode' }
    ]);
    const newDoc = this.docsForm.value;
    const exists = this.gridData.some(item => item.docType === newDoc.docType && newDoc.docType.toLowerCase() !== DocType.Other.toLowerCase() && newDoc.docType.toLowerCase() !== DocType.SupplierOther.toLowerCase());
    if (exists) {
      return;
    }
    if(newDoc.docType.toLowerCase()!==DocType.Other.toLowerCase() && newDoc.docType.toLowerCase()!=DocType.SupplierOther.toLowerCase() && desc!=null)
    {
      newDoc.docInfo=desc;
    }
    newDoc.isDelete = false;
    this.gridData.push(newDoc);
    this.clearData();
    if(this.saveDocumentOnUpload)
    {
      this.DocsSubmit();
    }
  }

  clearData() {
    this.submitted = false;
    this.docsForm.reset();
    this.docsForm.markAsPristine();
    this.docsForm.markAsUntouched();
    this.docsForm.get('docType')?.setErrors(null);
    this.docsForm.get('docType')?.updateValueAndValidity();
    this.isRequired = false;
    this.formInit();
  }

  handleDeleteItem(docId: number) {
    const deletedItem = this.gridData.find(x=>x.supDocId === docId || x.docsId === docId );
    this.gridData = this.gridData.map(item => {
      if ((item.docsId === deletedItem.docsId && deletedItem.docsId)|| (deletedItem.supDocId && item.supDocId === deletedItem.supDocId)) {
        return { ...item, isDelete: true };
      }
      return item;
    }); 
    if(this.saveDocumentOnUpload)
    {
      this.DocsSubmit();
    }
  }


  handleIsDelete(isDelete:boolean){
    this.isDeletePopUp = isDelete;
  }
  getFilteredGridData(): any[] {
    return this.gridData.filter(item => !item.isDelete);
  }

  formInit() {
    this.docsForm = this.formBuilder.group({
      docType: [null, [Validators.required]],
      docTypeName: [null],
      docInfo: [null],
      docName: ['', [Validators.required]],
      docFile: ['', [Validators.required]],
      file: ['', [Validators.required]],
      createdDate: [this.shareService.convertDateIntoUtc(new Date())],
      createdBy: [this.jwtService?.getUserId() ?? ''],
      Id: [this.Id, [Validators.required]],
      docsId: [0],
      isDelete: ["false"]
    });
  }

  isValueDisabled(value: string): boolean {
    if (value.toLowerCase() === DocType.Other.toLowerCase() || value.toLowerCase() === DocType.SupplierOther.toLowerCase()) {
      return false;
    }
    return this.gridData.some((item) => item.docType === value && !item.isDelete);
  }

  omitSpecialCharNumber(event: any) {
    this.validationService.omitSpecialCharNumber(event);
  }

  removeSpaces(e: any) {
    this.validationService.removeSpaces(e);
  }

  omitValidateSpecialChar(event: KeyboardEvent) {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }
  private getMissingFilters(): string[] {
    const filters: string[] = [];
    const requiredContexts = [
      LookUpConstants.JSDocsDocType
    ];
    if(this.jsService.lookupData?.lookUp?.length>0) {
      requiredContexts.forEach(context => {
        const contextExists = Object.values(this.jsService.lookupData.lookUp).some(
          (item: any) => item.lookUpContext === context
        );
        if (!contextExists) filters.push(context);
      });
    }
    else{
      filters.push(LookUpConstants.JSDocsDocType);
    }
    return filters
  }
 

  filterLookUpByContext(lookUp: any[], context: string): any[] {
    return lookUp.filter((x: any) => x.lookUpContext === context);
  }

  onFileSelected(event: any, controlKey: string) {
    const fileInput = event.target;
    if (fileInput.files.length > 0) {
      const fileName = fileInput.files[0].name;
      this.docsForm.get('docName')?.setValue(fileName);
      this.readBase64(event.target.files[0])
        .then((data) => {
          this.docsForm.get('file')?.setValue(data);
        });
    } else {
      this.docsForm.get('docName')?.setValue('');
    }
  }

  private readBase64(file: any): Promise<any> {
    const reader = new FileReader();
    const future = new Promise((resolve, reject) => {
      reader.addEventListener('load', function () {
        resolve(reader.result);
      }, false);
      reader.addEventListener('error', function (event) {
        reject(event);
      }, false);

      reader.readAsDataURL(file);
    });
    return future;
  }

  filterDT(e: any) {
    this.docType = this.filterItems(e, this.originalDocType, (unit) => unit.displayName);
  }

  onOptionSelectedDT(event: any) {
    const selectedValue = this.docsForm.controls['docType'].value?.lookUpCode;
    if (selectedValue?.toLowerCase() === this.docTypeList.Other?.toLowerCase()|| selectedValue?.toLowerCase() === this.docTypeList.SupplierOther?.toLowerCase()) {
      this.otherSelected();
    } else {
      this.isOtherSel = false;
      this.docsForm.get('docInfo')?.clearValidators();
      this.docsForm.get('docInfo')?.updateValueAndValidity();
    }
  }

  otherSelected() {
    this.isOtherSel = true;
    this.docsForm.get('docInfo')?.setValidators([Validators.required]);
    this.docsForm.get('docInfo')?.updateValueAndValidity();
  }

  clearInvalidFields(idField: string, nameField: string, valueField: string,idValueField: string, filteredListName: string, originalListName: string, isDocType : boolean = false) {
    const exactMatch = (this as any)[filteredListName].filter((x: any) => x[valueField].toLowerCase() == this.docsForm.controls[nameField].value.toLowerCase());
    if (exactMatch?.length == 1) {
      if(isDocType){
        this.docsForm.controls[idField].setValue(exactMatch[0][idValueField]);
        const selectedValue = exactMatch[0][idValueField];
        if (selectedValue === DocType.Other) {
          this.otherSelected();
        } else {
          this.isOtherSel = false;
          this.docsForm.get('docInfo')?.clearValidators();
          this.docsForm.get('docInfo')?.updateValueAndValidity();
        }
        this.onOptionChange();
      }
      else{
        this.docsForm.controls[idField].setValue(exactMatch[0][idValueField]);
      }
    } else {
      if(isDocType){
        this.onOptionChange();
      }
      this.shareService.clearFieldsIfIdNotSelected(this.docsForm, idField, nameField);
      (this as any)[filteredListName] = [...(this as any)[originalListName]];
    }
  }

  handlePaste(event: ClipboardEvent): void {
    this.handlePasteEvent(event, (text) => this.validationService.omitValidateSpecialCharString(text) as string);
  }
}
